export function createElementFromHtmlContent(document: Document, content: string): HTMLElement {
  const container = getContainer(document, content);
  container.innerHTML = content;
  return container.firstElementChild as HTMLElement;
}

function getContainer(document: Document, content: string): HTMLElement {
  switch (getMainElementTagName(content)) {
    case 'tr': {
      return document.createElement('tbody') as HTMLElement;
    }
    case 'td': {
      return document.createElement('tr') as HTMLElement;
    }
    case 'tbody': {
      return document.createElement('table') as HTMLElement;
    }
    default: {
      return document.createElement('div') as HTMLElement;
    }
  }
}

function getMainElementTagName(content: string): string {
  const stripped = content.trimStart().replace(/^(<!--[\s\S]*?-->\s*)+/, '');
  const match = stripped.trimStart().match(/^<([a-zA-Z][a-zA-Z0-9-]*)/);
  return match ? match[1].toLowerCase() : '';
}
